import { IApiCollectionItemFolderChild } from "@propely/propely-typings";
import { PathSegment } from "@src/data-hooks/documentation-collection/useDocumentationCollection";
import { useEffect, useState } from "react";
import SubFolderDropdown from "../SubFolderDropdown/SubFolderDropdown";
import { use } from "i18next";

export interface SubFolderDropdownWrapperProps {
  collectionId: string;
  propertyId: string;
  collectionItemId: string;
  parentFolderId?: string;
  folders?: IApiCollectionItemFolderChild[];
  selectedFolderId?: string;
  onSelectFolder: (relativeId: string, folderPath: PathSegment | undefined) => void;
}

const SubFolderDropdownWrapper = ({
  collectionId,
  propertyId,
  collectionItemId,
  parentFolderId,
  folders,
  selectedFolderId,
  onSelectFolder,
}: SubFolderDropdownWrapperProps) => {
  const [selectedFolder, setSelectedFolder] = useState<string | null>(null);

  useEffect(() => {
    if (selectedFolderId) {
      setSelectedFolder(selectedFolderId);
    }
  }, [selectedFolderId]);

  return (
    <SubFolderDropdown
      collectionId={collectionId}
      propertyId={propertyId}
      collectionItemId={collectionItemId}
      parentFolderId={parentFolderId}
      folders={folders}
      onSelectFolder={onSelectFolder}
      selectedFolder={selectedFolder} // Pass down selected folder state
      setSelectedFolder={setSelectedFolder} // Pass down setter function
    />
  );
};

export default SubFolderDropdownWrapper;
